import _classCallCheck from "/Users/benn/Dropbox/Mon Mac (MacBook-Pro.local)/Documents/Work/Personal Website/personal-site/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/benn/Dropbox/Mon Mac (MacBook-Pro.local)/Documents/Work/Personal Website/personal-site/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * Color
 *
 * An object representation of a color.
 */
import ColorSpace from './ColorSpace';
import DOMSelector from '../utils/DOMSelector';

var Color = /*#__PURE__*/function () {
  function Color() {
    var red = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var green = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var blue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck(this, Color);

    this.red = 0;
    this.green = 0;
    this.blue = 0;

    if (typeof red === 'string') {
      this.fromHex(red);
    } else {
      this.red = parseInt(red);
      this.green = parseInt(green);
      this.blue = parseInt(blue);
    }

    return this;
  }

  _createClass(Color, [{
    key: "fromHex",
    value: function fromHex() {
      var hex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (hex.length > 0) {
        if (hex[0] == '#') {
          hex = hex.slice(1);
        }

        if (hex.length == 3) {
          hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }

        this.red = parseInt(hex.slice(0, 2), 16);
        this.green = parseInt(hex.slice(2, 4), 16);
        this.blue = parseInt(hex.slice(4, 6), 16);
      } else {
        this.red = 0;
        this.green = 0;
        this.blue = 0;
      }

      return this;
    }
  }, {
    key: "setRed",
    value: function setRed() {
      var red = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.red = Math.min(255, Math.max(0, parseInt(red)));
      return this;
    }
  }, {
    key: "getRed",
    value: function getRed() {
      return this.red;
    }
  }, {
    key: "setGreen",
    value: function setGreen() {
      var green = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.green = Math.min(255, Math.max(0, parseInt(green)));
      return this;
    }
  }, {
    key: "getGreen",
    value: function getGreen() {
      return this.green;
    }
  }, {
    key: "setBlue",
    value: function setBlue() {
      var blue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.blue = Math.min(255, Math.max(0, parseInt(blue)));
      return this;
    }
  }, {
    key: "getBlue",
    value: function getBlue() {
      return this.blue;
    }
  }, {
    key: "toString",
    value: function toString(mode) {
      var color = '';
      var hslColor = null;

      switch (mode) {
        case 'rgb':
          color = 'rgb(' + this.red + ', ' + this.green + ', ' + this.blue + ')';
          break;

        case 'rgba':
          color = 'rgba(' + this.red + ', ' + this.green + ', ' + this.blue + ', 1)';
          break;

        case 'hsl':
          hslColor = ColorSpace.RGBtoHSL(this.red, this.green, this.blue);
          color = 'hsl(' + hslColor.hue + ', ' + hslColor.sat + '%, ' + hslColor.lig + '%)';
          break;

        case 'hsla':
          hslColor = ColorSpace.RGBtoHSL(this.red, this.green, this.blue);
          color = 'hsla(' + hslColor.hue + ', ' + hslColor.sat + '%, ' + hslColor.lig + '%, 1)';
          break;

        default:
          color = '#' + ((1 << 24) + (this.red << 16) + (this.green << 8) + this.blue).toString(16).slice(1);
          break;
      }

      return color;
    }
  }, {
    key: "useAsBackground",
    value: function useAsBackground(selector) {
      var _this = this;

      if (selector && typeof selector == 'object') {
        if ('css' in selector && typeof selector.css == 'function') {
          selector.css('background-color', this.toString());
        }
      } else {
        var elements = DOMSelector.querySelectorAll(selector);
        elements.map(function (element) {
          element.style['background-color'] = _this.toString();
        });
      }

      return this;
    }
  }, {
    key: "useAsColor",
    value: function useAsColor(selector) {
      var _this2 = this;

      if (selector && typeof selector == 'object') {
        if ('css' in selector && typeof selector.css == 'function') {
          selector.css('color', this.toString());
        }
      } else {
        var elements = DOMSelector.querySelectorAll(selector);
        elements.map(function (element) {
          element.style['color'] = _this2.toString();
        });
      }

      return this;
    }
  }]);

  return Color;
}();

export { Color as default };